import { useMutation } from '@tanstack/react-query'

import { dateToIso } from 'shared/utils/dateUtils'
import { useJWTToken } from 'App/Auth'

import { useLocationContext } from 'App/Root/Location'
import {
    createProcess,
    updateProcess,
} from '../services/process'

function useSaveProcess() {
    const token = useJWTToken()
    const { location } = useLocationContext()

    return useMutation({ mutationFn: ({
        processTemplate,
        groups,
        processId,
        processGroupId,
        currentGroup,
    }) => {
        const createData = {
            ...processTemplate,
            createdOnZoned: dateToIso(new Date()),
            changedOnZoned: dateToIso(new Date()),
            location: { id: location.locationId },
            progressGroups: groups,
        }

        const extendedData = processId ? {
            id: processGroupId,
            steps: groups[currentGroup.progressGroup - 1].steps,
        } : createData

        if (processId) {
            return updateProcess({
                token,
                data: extendedData,
            })
        }
        return createProcess(token, extendedData)
    } })
}

export default useSaveProcess
